import { selectApp } from "./selectApp";

export const selectInitialStep = state => selectApp(state).initialStep;
